import repository from './repsitory'

const resource = '/sliderImage'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addSliderImage (data) {
        return repository.post(`${resource}`, data)
    },
    // updateSliderImage (data, id) {      //no editar- eliminar y agregar otra
    //     return repository.put(`${resource}/${id}`, data)
    // },
    remove (id) {
        return repository.delete(`${resource}/${id}`)
    },
}
